import React, { Component } from "react";

import {
  CloseCircleFilled, FileExcelOutlined, FileImageOutlined, FilePdfOutlined,
} from "@ant-design/icons";
import { Checkbox } from "antd";

import "./DocumentsCard.css";
import DocumentsMenuOption from "./DocumentsMenuOption";

export default class DocumentsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cardHover: false,
      menuOpen: false,
    };
  }

  handleCardEnter = () => {
    this.setState({
      cardHover: true,
    });
  };

  handleCardLeave = () => {
    this.setState({
      cardHover: false,
    });
  };

  renderFileIcon = (extension) => {
    switch (extension) {
      case "pdf":
        return <FilePdfOutlined className="docCardFileIcon" />;
      case "xlsx":
        return <FileExcelOutlined className="docCardFileIcon" />;
      default:
        return <FileImageOutlined className="docCardFileIcon" />;
    }
  }

  onOpenChange = (isOpen) => {
    this.setState({ menuOpen: isOpen, cardHover: isOpen });
  }

  render() {
    const { cardHover, menuOpen } = this.state;
    const {
      file,
      readOnly,
      handleFileOptionClick,
      handleCheckbox,
      handleNameChange,
      handleNameSubmit,
      handleCancelRename,
      handleRenameFile,
      handleConfirmDelete,
      handleDownloadFile,
    } = this.props;

    return (
      <div className="docCardFileAndName">
        <div
          onMouseEnter={menuOpen ? null : this.handleCardEnter}
          onMouseLeave={menuOpen ? null : this.handleCardLeave}
          className={
            file.checked ? "docFileCard docFileCardSelected" : "docFileCard"
          }
        >
          {cardHover && (
            <div className="docCardHoverInputs">
              <span onClick={(e) => e.stopPropagation()}>
                <Checkbox
                  onChange={(e) => handleCheckbox(e, file.key)}
                  checked={Boolean(file.checked)}
                  aria-label={`Select ${file.name}`}
                />
              </span>
              {!readOnly && (
              <div
                onClick={(e) => handleFileOptionClick(e, file)}
                className="docDotIconWrapper"
              >
                <DocumentsMenuOption
                  handleRenameFile={() => handleRenameFile(null, file)}
                  handleConfirmDelete={() => handleConfirmDelete(null, file, false)}
                  handleDownloadFile={() => handleDownloadFile(null, file, false)}
                  handleFileOptionClick={(e) => handleFileOptionClick(e)}
                  onOpenChange={this.onOpenChange}
                />
              </div>
              )}
            </div>
          )}

          <div className="docCardFileIconName">
            {this.renderFileIcon(file.extension)}
          </div>
        </div>
        <div
          // onDoubleClick={(e) => handleRenameFile(e, file)}
          className="docCardFileName"
        >
          {file.renameDisable ? (
            file.name
          ) : (
            <div className="DocCardFileName--relative-position">
              <input
                disabled={file.renameDisable}
                className={
                  !file.renameDisable
                    ? "docFileNameInputCard docFileNameInputEdit"
                    : "docFileNameInputCard"
                }
                onChange={(e) => handleNameChange(e, file.key)}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => handleNameSubmit(e, file.key)}
                // onDoubleClick={(e) => handleRenameFile(e, file)}
                type="text"
                value={file.renameValue}
              />
              <CloseCircleFilled
                role="button"
                aria-label="Cancel rename"
                className="DocFileNameInputCard__CloseIcon"
                onClick={(e) => handleCancelRename(e, file.key)}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
